module.exports = __webpack_public_path__ + "f7aaeaa7f1ebd5ee0a860220c077021d.svg";